module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('span', {
    staticClass: "epub-intro"
  }, [_vm._v("INTRODUCTION TO")])]), _vm._v(" "), _c('p', {
    staticClass: "H1SUB"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("“SAM BELOW PAR”")])]), _vm._v(" "), _c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("I am not a golfer. I’m a writer. Hardly any of the writers I know have the time to play golf. Writers "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("write")]), _vm._v(". They don’t fritter away hour upon hour trying to knock a little white ball into a hole in the ground.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But once I fell in love with the ravishing Rashida, who is an ardent golfer, I perforce began to learn a few things about the game. And as I did, Sam Gunn came up and tapped me on my metaphysical shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I want to build a golf course,” Sam said to me. “On the Moon.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sam is a scoundrel, of course. A skirt chaser. A man who can bend the rules into pretzels. A little guy, physically, Sam is always battling against the Big Guys: the corporate “suits,” the government bureaucrats, the rich and powerful. Sam makes and loses fortunes the way you or I change socks. But he has a heart as big as the solar system, and despite his many enemies, he also has a legion of friends.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But a golf course on the Moon? I mean, the Moon is a new frontier, yes, but who would want to build a golf course on its airless, barren surface?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Who else but Sam Gunn?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Why")]), _vm._v(" would he want to build a golf course on the Moon?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Thereby hangs a tale.… ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f604df2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 72
// module chunks = 0